function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#2B9FFD",
  fillRule: "evenodd",
  d: "M7 13.222A6.222 6.222 0 117 .778a6.222 6.222 0 010 12.444zM4.063 9.147a.566.566 0 00.8.8l2.14-2.141L9.144 9.95a.565.565 0 00.8-.8L7.802 7.004l2.151-2.153a.566.566 0 00-.8-.8l-2.15 2.153-2.149-2.15a.565.565 0 10-.8.8l2.149 2.15-2.14 2.142z"
});

var SvgCloseIcon = function SvgCloseIcon(props) {
  return React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14"
  }, props), _ref);
};

export default SvgCloseIcon;